import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgFilter = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#666666", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M10 18V16H14V18H10ZM6 13V11H18V13H6ZM3 8V6H21V8H3Z", fill: "inherit" }) });
const ForwardRef = forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
